export const getUrlParams = (url: Location): URLSearchParams => {
  const _url = new URL(url.href);
  const _searchParams = new URLSearchParams(_url.search);
  return _searchParams;
};
